var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiGreenBigsmile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
    fill: "#83BB26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.27 18.3895C14.27 21.0275 12.1288 23.1686 9.49081 23.1686C6.85277 23.1686 4.71167 21.0275 4.71167 18.3895C4.71167 15.7515 6.85277 13.6104 9.49081 13.6104C12.1288 13.6104 14.27 15.7484 14.27 18.3895Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34973 16.5397C9.34973 17.3157 8.7209 17.9446 7.94482 17.9446C7.16875 17.9446 6.53992 17.3157 6.53992 16.5397C6.53992 15.7636 7.16875 15.1348 7.94482 15.1348C8.7209 15.1348 9.34973 15.7636 9.34973 16.5397Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8895 18.7546C10.8895 19.2025 10.5276 19.5645 10.0797 19.5645C9.63186 19.5645 9.2699 19.2025 9.2699 18.7546C9.2699 18.3068 9.63186 17.9448 10.0797 17.9448C10.5276 17.9448 10.8895 18.3068 10.8895 18.7546Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2884 18.3895C43.2884 21.0275 41.1503 23.1686 38.5092 23.1686C35.8681 23.1686 33.7301 21.0275 33.7301 18.3895C33.7301 15.7515 35.8681 13.6104 38.5092 13.6104C41.1503 13.6104 43.2884 15.7484 43.2884 18.3895Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3682 16.5397C38.3682 17.3157 37.7393 17.9446 36.9633 17.9446C36.1872 17.9446 35.5583 17.3157 35.5583 16.5397C35.5583 15.7636 36.1872 15.1348 36.9633 15.1348C37.7393 15.1348 38.3682 15.7636 38.3682 16.5397Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.908 18.7546C39.908 19.2025 39.546 19.5645 39.0981 19.5645C38.6503 19.5645 38.2883 19.2025 38.2883 18.7546C38.2883 18.3068 38.6503 17.9448 39.0981 17.9448C39.546 17.9448 39.908 18.3068 39.908 18.7546Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9203 27.2426C12.9203 28.5861 11.4571 29.6751 9.64726 29.6751C7.83744 29.6751 6.37732 28.5861 6.37732 27.2426C6.37732 25.899 7.84051 24.8101 9.64726 24.8101C11.454 24.8101 12.9203 25.899 12.9203 27.2426Z",
    fill: "#FFD525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6196 27.2426C41.6196 28.5861 40.1533 29.6751 38.3497 29.6751C36.546 29.6751 35.0767 28.5861 35.0767 27.2426C35.0767 25.899 36.5429 24.8101 38.3497 24.8101C40.1564 24.8101 41.6196 25.899 41.6196 27.2426Z",
    fill: "#FFD525"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.8066C26.5614 28.8066 28.8559 29.8096 30.408 31.3986C31.224 30.4691 31.8743 29.3648 32.3068 28.1378C32.8497 26.598 31.908 24.8955 30.5031 24.8955H17.4939C16.0921 24.8955 15.1473 26.598 15.6933 28.1378C16.1258 29.3618 16.7761 30.4691 17.5921 31.3986C19.1442 29.8127 21.4387 28.8066 24 28.8066Z",
    fill: "#1C1C1C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.3864C26.5154 34.3864 28.7884 33.2392 30.408 31.3956C28.8558 29.8097 26.5614 28.8066 24 28.8066C21.4387 28.8066 19.1442 29.8097 17.592 31.3956C19.2117 33.2392 21.4816 34.3864 24 34.3864Z",
    fill: "#FF2180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiGreenBigsmile);
export default __webpack_public_path__ + "static/media/emoji_green_bigsmile.fc49e2a0.svg";
export { ForwardRef as ReactComponent };